export function getReaderFocus(data) {
  if (!data.acf) {
    return;
  }

  const foc = {
    ...data.acf.reader_profile_focus_hdfocus,
    ...data.acf.reader_profile_focus_genre,
    ...data.acf.reader_profile_focus_expertise,
  };

  const keys = Object.keys(foc);
  const filtered = keys.filter((key) => foc[key]);
  return filtered.map((e) => {
    const split = e.split('_');
    return split[split.length - 1];
  });
}
